
<template>
  <v-card elevation="1">
    
    <!-- <v-card-title class="d-flex justify-space-between align-center">
      <span class="text-h6 text-capitalize">
        {{ entityType }}
      </span>

      <CreationBox @create="handleCreate" />
    </v-card-title> -->
    <v-card-title class="d-flex justify-space-between align-center">
    
      <CreationBox
      :canShow="canShowCreationBox"
      :entityType="entityType"
      @create="handleCreate" />
    </v-card-title>

    <v-card-text>
      <SummaryTable
        :items="entityState.items"
        :entityType="entityType"
        @edit="handleEdit"
        @delete="handleDelete"
      />
    </v-card-text>

  </v-card>

  <EditDrawer
    v-if="drawerOpen"
    v-model="drawerOpen"
    :entityType="entityType"
    :itemId="selectedItemId"
    :itemName="selectedItemName"
    @cancel="handleCancel"
    @completed="handleUpdateCompleted"
  />
</template>


<script setup>
import { ref, computed, onMounted , watch} from 'vue'
import { useEntityStore } from '@/store/useEntityStore'
import CreationBox from '@/components/entity/CreationBox.vue'
import SummaryTable from '@/components/entity/SummaryTable.vue'
import EditDrawer from '@/components/entity/EditDrawer.vue'
import { useEntityRoute } from '@/composables/route/useListViewRoute'
import { usePermissionGuard } from '@/composables/usePermissionGuard'
import { useLoaderStore } from "@/store/loader"
const { entityType, listViewTargetId, updateListViewTargetId } = useEntityRoute()
const { canAccess } = usePermissionGuard()
const loader = useLoaderStore()

const store = useEntityStore()
const drawerOpen = ref(false)
const selectedItemId = ref("")
const selectedItemName = ref("")

const entityState = computed(() =>
  store.getEntityState(entityType.value)
)

function handleCreate() {
  drawerOpen.value = true
  store.startCreate(entityType.value)
}

const canShowCreationBox = computed(() => {
  return canAccess({ entityType: entityType.value })
})

async function handleEdit(item) {
  selectedItemName.value = item.username || item.name || null
  updateListViewTargetId(item.id)
}

async function openDrawer(id){
  selectedItemId.value = id
  await store.fetchDetail(entityType.value, id)
  drawerOpen.value = true
}

watch(
  listViewTargetId,
  async (id) => {
    if (!id) {
      drawerOpen.value = false
      selectedItemId.value = null
      return
    }

    await openDrawer(id)
  },
  { immediate: true }
)


async function handleDelete(id) {
  await store.delete(entityType.value, id)
}

async function handleCancel() {
  updateListViewTargetId("")
  drawerOpen.value = false
}

async function handleUpdateCompleted(success, errorMessage) {
  // also show status update
  if(success){
    updateListViewTargetId("")
    drawerOpen.value = false
  }
  else {
    updateListViewTargetId("")
    loader.setAlert({ message: errorMessage, timeout: 5000, type: "error" });
  }}

onMounted(() => { 
  store.fetchAllSummaries() 
  store.fetchAllEntityConfig()
  })
</script>
